/**
 * KPI 配置服务
 */

import axios from 'axios';
import { KPIConfig } from './types';
import { getListResponse, API_BASE } from './utils';

export const kpiConfigService = {
    list: async (params?: { department_id?: number; is_active?: boolean }): Promise<KPIConfig[]> => {
        const response = await axios.get(`${API_BASE}/kpi-configs/`, { params });
        return getListResponse(response.data);
    },

    get: async (id: number): Promise<KPIConfig> => {
        const response = await axios.get(`${API_BASE}/kpi-configs/${id}/`);
        return response.data;
    },

    create: async (data: Partial<KPIConfig>): Promise<KPIConfig> => {
        const response = await axios.post(`${API_BASE}/kpi-configs/`, data);
        return response.data;
    },

    update: async (id: number, data: Partial<KPIConfig>): Promise<KPIConfig> => {
        const response = await axios.patch(`${API_BASE}/kpi-configs/${id}/`, data);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await axios.delete(`${API_BASE}/kpi-configs/${id}/`);
    },

    batchUpdate: async (departmentId: number, configs: any[]): Promise<{ message: string; data: KPIConfig[] }> => {
        const response = await axios.post(`${API_BASE}/kpi-configs/batch_update/`, {
            department_id: departmentId,
            configs,
        });
        return response.data;
    },

    getWeightSummary: async (departmentId: number): Promise<{ department_id: number; total_weight: number; is_valid: boolean }> => {
        const response = await axios.get(`${API_BASE}/kpi-configs/weight_summary/`, {
            params: { department_id: departmentId },
        });
        return response.data;
    },
};
